import { createApp} from 'vue'
// import VueFullPage from 'vue-fullpage.js'
import {createRouter, createWebHistory} from 'vue-router'
import App from "@/App";
// import { basename, extname } from 'path'
// import { config } from '@xytoki/asset-loader'
// config.urlToKey = function(url) {
//   return basename(url).replace(extname(url), '')
// }
const routes = [
  { path: '/', component: () => import(/* webpackChunkName: "home" */"@/views/Home") },
  { path: '/team', component: () => import(/* webpackChunkName: "team" */"@/views/Team") },
  { path: '/another-model', component: () => import(/* webpackChunkName: "team" */"@/views/AnotherModel") },
  { path: '/:page', component: () => import(/* webpackChunkName: "detail" */"@/views/Detail") },
  // { path: '/attributions', component: () => import(/* webpackChunkName: "detail" */"@/views/Attribution") },
  {path: '/game',component:()=> import ("@/views/Game")}
]

const router = createRouter({
  history: createWebHistory("/tjusls-china/"),
  routes,
})

const app = createApp(App)
app.use(router)
// app.use(VueFullPage)
app.mount('#app')
window.onload = () => {
  document.querySelector("#app").style = null;
  try{
    document.querySelector("#app-load").style = "display: none;";
  }catch (e){
    console.log("not found ele app-load")
  }
}
